import React from "react";
import CommissaryLayout from "../../layout/CommissaryLayout";

const Commissaryconfigs = () => {
  return <CommissaryLayout>Commissaryconfigs</CommissaryLayout>;
};

export default Commissaryconfigs;
